export default __webpack_public_path__ + "8d148007de4dad9452c3c5615b65f754.svg";